import { useEffect, useState } from 'react';

import { isBrowser } from '../../../core/utils/isBrowser.js';

/** @internal */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (!isBrowser) {
      return false;
    }
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (!isBrowser) {
      return undefined;
    }
    const mql = window.matchMedia(query);
    setMatches(mql.matches);
    const listener = (e: MediaQueryListEvent) => setMatches(e.matches);
    mql.addEventListener('change', listener);
    return () => mql.removeEventListener('change', listener);
  }, [query]);

  return matches;
}
